import { useEffect, useState } from "react";
import { onSnapshot } from "firebase/firestore";
import { useUsuario } from "../../../providers/usuarioProvider";
import UsuarioDb from "../../../db/usuarioDb";
import Usuario from "../../../models/usuario";
import DiscoveryInternacional from "./discoveryInternacional";
import TimelineInternacional from "./timelineInternacional";

export default function MercadoInternacional() {
  const { visualizado } = useUsuario();
  const [usuario, setUsuario] = useState<Usuario>();

  useEffect(() => {
    if (visualizado) {
      return onSnapshot(
        new UsuarioDb().doc({ usuarioId: visualizado }),
        (snapshot) => setUsuario(snapshot.data())
      );
    }
  }, [visualizado]);

  if (!usuario?.preferencias?.mercadoInternacional) {
    return <DiscoveryInternacional />;
  }
  return <TimelineInternacional />;
}
